export default __webpack_public_path__ + "static/media/mamadash.9fe19b28.png";